"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var IntegrationJob_1 = require("./IntegrationJob");
var Integration_module_css_1 = __importDefault(require("../Integration.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_i18next_1 = require("react-i18next");
var IntegrationHelper_1 = __importDefault(require("@/Helper/IntegrationHelper"));
var JobLogModal = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = (0, react_1.useState)([]), integrationJobs = _f[0], setIntegrationJobs = _f[1];
    var _g = (0, react_1.useState)(props.currentJob), currentIntegrationJob = _g[0], setCurrentIntegrationJob = _g[1];
    var _h = (0, react_1.useState)(undefined), errorImageUrl = _h[0], setErrorImageUrl = _h[1];
    var isDynamicResource = false;
    var resourceTemplate = ((_b = (_a = props.integration) === null || _a === void 0 ? void 0 : _a.definition) === null || _b === void 0 ? void 0 : _b.scripts) ? (_e = (_d = (_c = props.integration) === null || _c === void 0 ? void 0 : _c.definition) === null || _d === void 0 ? void 0 : _d.scripts[props.script]) === null || _e === void 0 ? void 0 : _e.template : undefined;
    if (props.script && resourceTemplate && props.integrationTemplate.definition.script.scripts[resourceTemplate]) {
        var template = props.integrationTemplate.definition.script.scripts[resourceTemplate];
        if (template.resources) {
            for (var i in template.resources) {
                if (template.resources[i].dynamic) {
                    isDynamicResource = true;
                    break;
                }
            }
        }
    }
    var loadJobLog = function (script, jobId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!currentIntegrationJob) return [3 /*break*/, 2];
                    _a = setCurrentIntegrationJob;
                    return [4 /*yield*/, props.jobState.loadScriptJob(script, jobId)];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var runScript = function () {
        IntegrationHelper_1.default.runScript(props.integration.id, props.script);
    };
    (0, react_1.useEffect)(function () {
        if (currentIntegrationJob) {
            var loadErrorImage = function () { return __awaiter(void 0, void 0, void 0, function () {
                var imageUrl, response, blob, objectUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            imageUrl = "/api/content/integration/".concat(props.integration.id, "/").concat(currentIntegrationJob.resource, "/error/").concat(currentIntegrationJob.id);
                            return [4 /*yield*/, fetch(imageUrl)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.blob()];
                        case 2:
                            blob = _a.sent();
                            objectUrl = URL.createObjectURL(blob);
                            setErrorImageUrl(objectUrl);
                            return [2 /*return*/];
                    }
                });
            }); };
            if (currentIntegrationJob.logs === undefined) {
                loadJobLog(currentIntegrationJob.resource, currentIntegrationJob.id);
            }
            if (currentIntegrationJob === null || currentIntegrationJob === void 0 ? void 0 : currentIntegrationJob.has_failure_result) {
                loadErrorImage();
            }
        }
    }, [currentIntegrationJob]);
    (0, react_1.useEffect)(function () {
        if (props.jobState) {
            var fetchJobs_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
                var jobs, current;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, props.jobState.getScriptJobs(props.script)];
                        case 1:
                            jobs = _a.sent();
                            setIntegrationJobs(jobs);
                            if (!currentIntegrationJob && jobs.length > 0) {
                                current = jobs[0];
                                if (!jobs[0].ended_at && jobs[1]) {
                                    current = jobs[1];
                                }
                                setCurrentIntegrationJob(current);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            props.jobState.onJobListChanged(function () {
                fetchJobs_1();
            });
            fetchJobs_1();
        }
    }, [props.jobState]);
    var ModalBody = function () {
        var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between", gap: "10px" } },
                react_1.default.createElement("div", { style: { width: "75%" } },
                    react_1.default.createElement("div", { style: { width: "100%" } },
                        react_1.default.createElement(IntegrationJob_1.IntegrationJobOutputLog, { job: currentIntegrationJob })),
                    errorImageUrl
                        ? react_1.default.createElement("div", { style: { width: "100%" } },
                            react_1.default.createElement("a", { href: errorImageUrl, target: "_blank", rel: "noreferrer" },
                                react_1.default.createElement("img", { src: errorImageUrl, style: { maxHeight: "150px" } })))
                        : react_1.default.createElement(react_1.default.Fragment, null)),
                react_1.default.createElement("div", { style: { width: "25%" } },
                    react_1.default.createElement("div", { className: Integration_module_css_1.default["ns-page-card"], style: { width: "100%" } },
                        react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between", margin: "-10px -10px" } },
                            react_1.default.createElement("div", null),
                            react_1.default.createElement("div", { style: { display: "flex", gap: "5px" } }, isDynamicResource
                                ? (react_1.default.createElement("div", { title: t("Run script"), style: { padding: "2px 6px 0 14px", border: "1px solid #ccc", borderRadius: "4px", opacity: ".5" } },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-play", style: { color: "var(--success-color)", marginRight: "5px" } })))
                                : (react_1.default.createElement("div", { title: t("Run script"), onClick: runScript, style: { padding: "2px 6px 0 14px", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer" } },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-play", style: { color: "var(--success-color)", marginRight: "5px" } })))))),
                    react_1.default.createElement("div", { className: Integration_module_css_1.default["ns-page-card"], style: { width: "100%" } },
                        react_1.default.createElement("div", { style: { margin: "-10px -10px" } }, integrationJobs && integrationJobs.map(function (item) {
                            var style = { padding: "5px 10px", border: "1px solid #ccc", borderRadius: "4px", marginBottom: "4px" };
                            if (item === currentIntegrationJob) {
                                style.backgroundColor = "#eee";
                            }
                            return (react_1.default.createElement("div", { key: item.id, style: style },
                                react_1.default.createElement(IntegrationJob_1.IntegrationJobListEntry, { job: item, selected: item === currentIntegrationJob, onSelect: function (job) { return setCurrentIntegrationJob(job); } })));
                        })))))));
    };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: props.onClose, body: react_1.default.createElement(ModalBody, null), dialogClassName: Integration_module_css_1.default["integration-script-debug-modal"] }));
};
exports.default = JobLogModal;
